import { Component, Input, OnChanges, OnInit } from "@angular/core";
import moment from "moment";

@Component({
  selector: "medication-summary",
  templateUrl: "medication-summary.html",
})
export class MedicationSummaryComponent implements OnInit, OnChanges {
  submittedBy: string;
  approvedBy: string;
  category: string;
  issue: string;
  name: string;
  dosage: string;
  dosageParams: string;
  route: string;
  frequency: string;
  startDate: string;
  dcDate: string;
  physician: string;
  physicianOrder: string;
  hospicePays: string;
  administeredBy: string;
  teachingsPerformed: string;

  @Input() data: any = {};

  constructor() {}

  ngOnInit() {
    this.refresh();
  }

  // medication-history binds [data]="selectedMedicationData", which starts null
  // and changes every time the user picks a different medication in the list.
  // Reading the fields in ngOnInit alone froze the summary on the first value.
  ngOnChanges() {
    this.refresh();
  }

  private refresh() {
    if (this.data) {
      this.submittedBy = this.data.submittedBy || "N/A";
      this.approvedBy = this.data.approvedBy || "N/A";
      this.category = this.data.category || "N/A";
      this.issue = this.data.issue || "N/A";
      this.name = this.data.name || "N/A";
      this.dosage = this.data.dosage || "N/A";
      this.dosageParams = this.data.dosageParams || "N/A";
      this.route = this.data.route || "N/A";
      this.frequency = this.data.frequency || "N/A";
      this.startDate = this.data.startDate || "N/A";
      this.dcDate = this.data.dcDate || "N/A";
      this.physician = this.data.physician || "N/A";
      this.physicianOrder = this.data.physicianOrder || "N/A";
      this.hospicePays = this.data.hospicePays || "N/A";
      this.administeredBy = this.data.administeredBy || "N/A";
      this.teachingsPerformed = this.data.teachingsPerformed || "N/A";
    }
  }

  getStringForBool(bool) {
    return bool ? "yes" : "no";
  }

  convertDate(input) {
    // Two separate traps here:
    //  1. moment().utc(input) builds a moment for NOW and then sets its UTC
    //     offset, DISCARDING `input` — every date rendered as the current time.
    //  2. A medication that has not been discontinued has no D/C date, and
    //     formatting an absent one yields the literal string "Invalid date",
    //     which is what the summary showed a clinician. Render nothing instead.
    if (!input) {
      return "";
    }
    const converted = moment.utc(input).local();
    return converted.isValid() ? converted.format("MM/DD/YYYY HH:mm") : "";
  }
}



// WEBPACK FOOTER //
// ./src/components/medication-administration-records/medication-summary/medication-summary.ts